import { CustomersTableActionTypes, CustomersTableActions, UserCustomersPageChange } from '@appStore/customers/actions/customers-table.actions';
import { TableState } from '@model';

export interface State {
  usersTable: TableState;
  invitationsTable: TableState;
  customersTable: TableState;
  userCustomersTable: TableState;
}

export const initialState: State = {
  usersTable: TableState.initialState('name'),
  invitationsTable: TableState.initialState('email'),
  customersTable: TableState.initialState('customerName'),
  userCustomersTable: TableState.initialState('customerName')
};

export function reducer(state = initialState, action: CustomersTableActions): State {
  switch (action.type) {
    case CustomersTableActionTypes.CustomersUsersPageChange:
      return { ...state, usersTable: action.payload };
    case CustomersTableActionTypes.CustomerInvitationsPageChange:
      return { ...state, invitationsTable: action.payload };
    case CustomersTableActionTypes.CustomersPageChange:
      return { ...state, customersTable: action.payload };
    case CustomersTableActionTypes.CustomersTableStateReset:
      return initialState;
    case CustomersTableActionTypes.UserCustomersPageChange:
      return {...state, userCustomersTable: action.payload };
  }

  return state;
}

export const getCustomerUsersTableState = (state: State) => state.usersTable;
export const getCustomerInvitationsTableState = (state: State) => state.invitationsTable;
export const getCustomerCustomersTableState = (state: State) => state.customersTable;
export const getCustomerUserCustomersTableState = (state: State) => state.userCustomersTable;
